import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";
import { DPR_API } from "../../../../services/apiCalls/dprApiCalls";

export default function Manpower({ project }) {
  const [open, setOpen] = useState(false);
  const [manpowerData, setManpowerData] = useState([]);
  const [filterData, setFilterData] = useState({
    ProjectID: project.project_id,
    startDate: "",
    endDate: "",
    Role: "",
    RoleType: "",
    Resource_name: "",
    sortOrder: "ASC",
    sortBy: "Role",
  });
  const [role, setRole] = useState([]);
  const [roleType, setRoleType] = useState([]);
  const getRole = async () => {
    const role = await DPR_API.get_Resource_role();
    if (role && role?.Role.length) {
      setRole(role.Role);
    } else {
      setRole([]);
    }
  };
  const getRoleType = async () => {
    const roleType = await DPR_API.get_Resource_role_type();
    if (roleType && roleType?.Role_type.length) {
      setRoleType(roleType.Role_type);
    } else {
      setRoleType([]);
    }
  };
  useEffect(() => {
    getRole();
    getRoleType();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(manpowerData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = manpowerData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalManpower = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.GetResourcesManpowerDetails(obj);
    if (response && response.ManpowerList.length > 0) {
      setManpowerData(response.ManpowerList);
    } else {
      setManpowerData([]);
    }
  };
  useEffect(() => {
    fetchArchivalManpower();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <React.Fragment>
      <Modal open={open} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Resource Manpower Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => setOpen(false)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="startDate"
                    value={filterData.startDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={filterData.endDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Role</label>
                  <select
                    name="Role"
                    value={filterData.Role}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="">Select role</option>
                    {role?.length
                      ? role.map((val) => (
                          <option key={val.role_id} value={val.role_id}>
                            {val.role_name}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
                <div className="col-6">
                  <label className="filter-label">Role Type</label>
                  <select
                    name="RoleType"
                    value={filterData.RoleType}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option value="">Select role type</option>
                    {roleType?.length
                      ? roleType.map((val) => (
                          <option key={val.roleType_id} value={val.roleType_id}>
                            {val.roletype_name}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Resource Name</label>
                  <input
                    type="text"
                    name="Resource_name"
                    value={filterData.Resource_name}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Manpower</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={filterData.sortOrder}
                onChange={handleChange}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="ASC">ASC</option>
                <option value="DES">DES</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginLeft: 20 }}>
          {["Role", "Type", "Created"].map((sortOption) => (
            <div className="form-check" key={sortOption}>
              <input
                className="form-check-input shadow-none"
                type="radio"
                name="sortBy"
                id={sortOption}
                value={sortOption}
                checked={filterData.sortBy === sortOption}
                onChange={handleChange}
              />
              <label htmlFor={sortOption} style={{ fontSize: 14 }}>
                {sortOption}
              </label>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchArchivalManpower(filterData);
              setOpen(false);
              setCurrentPage(1);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={manpowerData}
              fileName="Manpower"
              sheet="Manpower List"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalManpower()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              {/* <th>Project Name</th>
              <th>Project ID</th>
              <th>Region</th>
              <th>Location</th>
              <th>Client</th>
              <th>Product Category</th>
              <th>Project Status</th> */}
              <th>Role</th>
              <th style={{ whiteSpace: "nowrap" }}>Role Type</th>
              <th>Resource Name</th>
              <th>Number of Resources</th>
              <th> Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>
                  <td>{index + 1 + (currentPage - 1) * 10}</td>
                </td>
                {/* <td>{project.Project_Name}</td>
                <td>{project.project_id}</td>
                <td>{project.Region}</td>
                <td>{project.Location}</td>
                <td>-</td>
                <td>{project.Product_Category}</td>
                <td>{project.ProjectStatus}</td> */}
                <td style={{ whiteSpace: "nowrap" }}>{row.Role}</td>
                <td>{row.Role_Type}</td>
                <td>{row.Resource_Name}</td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  <span className="no-of-resource">
                    {row.Number_of_Resources}
                  </span>
                </td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min((currentPage - 1) * rowsPerPage + 1, manpowerData.length)}{" "}
          to {Math.min(currentPage * rowsPerPage, manpowerData.length)} of{" "}
          {manpowerData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
